/*
 * @Author: Src
 * @Date: 2025-05-19 09:23:10
 * @LastEditTime: 2025-05-19 13:42:13
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/download.service.ts
 * @Description: 头部注释配置模板
 */
import { inject, injectable } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class DownloadService {
  @inject(HttpClient)
  private http!: HttpClient;

  async download(data: any) {
    try {
      const response = await this.http.post('bi/download/data', { url: data }, { responseType: 'arraybuffer' }) as any;
      return response;
    } catch (error) {
      return null;
    }
  }
}
